import React from 'react';
import { DriverDashboard } from '../components/dashboard/DriverDashboard';

const DriverPage = () => {
  return <DriverDashboard />;
};

export default DriverPage;
